// extracted by mini-css-extract-plugin
export default {"post_container":"Post_post_container__4FS3R","body":"Post_body__lDng3","tags":"Post_tags__7kyfC","loading":"Post_loading__BZONy"};